<script>
/* COMPOSANTS */
import GaMessages from '@components/ga/layout/GaMessages.vue';
import AkAutocomplete from '@components/v2/input/AkAutocomplete';
import AkCalendar from '@components/v2/input/AkCalendar';
import MultiSelect from 'primevue/multiselect';
import AkButtonFooterSidebarFilter from '@components/v2/general/AkButtonFooterSidebarFilter.vue';

/* MIXINS */
import accommodationAutocompleteMixin from '@mixins/autocomplete/accommodationAutocompleteMixin';
import housekeeperAccommodationAutocompleteMixin from '@mixins/autocomplete/housekeeperAccommodationAutocompleteMixin';
import ownerAutocompleteMixin from '@mixins/autocomplete/ownerAutocompleteMixin';
import mandatAutocompleteMixin from '@mixins/autocomplete/mandatAutocompleteMixin';
import accountOperationsConst from '@mixins/const/accountOperationsConst';
import companyMixin from '@mixins/companyMixin';
import permissionsMixin from '@mixins/permissionsMixin';
import sidebarMixin from '@mixins/sidebarMixin';
import utilsMixin from '@mixins/utilsMixin';
import messageMixin from '@mixins/messageMixin';

import itemLabelService from '@services/itemLabelService';

/* SERVICES */

export default {
  components: {
    GaMessages,
    AkAutocomplete,
    AkCalendar,
    MultiSelect,
    AkButtonFooterSidebarFilter,
  },
  mixins: [
    accommodationAutocompleteMixin,
    housekeeperAccommodationAutocompleteMixin,
    mandatAutocompleteMixin,
    accountOperationsConst,
    companyMixin,
    ownerAutocompleteMixin,
    permissionsMixin,
    sidebarMixin,
    utilsMixin,
    messageMixin,
  ],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      mandatMarcheList: undefined,
    };
  },
  watch: {
    'currentValue.period': function (newVal, oldVal) {
      if (!newVal) {
        this.$refs.sidebarMessages.error(this.$t('recapitulatif_facturation.error_empty_filter'), true, false);
      } else {
        this.$refs.sidebarMessages.resetMessages();
      }
    },
  },
  mounted() {
    let p5 = itemLabelService.itemLabels({type: 'MARCHE'});
    p5.then((data) => {
      this.mandatMarcheList = data;
    });

    if (!this.currentValue.period) {
      this.$refs.sidebarMessages.error(this.$t('recapitulatif_facturation.error_empty_filter'), true, false);
    }
  },
  methods: {
    itemSelect(item) {
      this.$nextTick(() => {
        if (this.currentValue.period) {
          this.callback[0]();
        }
      });
    },
    search() {
      if (this.currentValue.period) {
        this.callback[0]();
        this.hideSidebar();
      }
    },
    reset() {
      if (this.$refs.ownerAutocomplete) this.$refs.ownerAutocomplete.reset();
      if (this.$refs.accommodationAutocomplete) this.$refs.accommodationAutocomplete.reset();
      if (this.$refs.mandatAutocomplete) this.$refs.mandatAutocomplete.reset();
      this.callback[1]();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <div class="mb-4">
    <GaMessages ref="sidebarMessages" />
  </div>
  <form class="flex flex-col gap-4" @submit.prevent>
    <!--AGENCE-->
    <MultiSelect
      v-if="this.isGas()"
      v-model="currentValue.companyIds"
      @change="itemSelect"
      :placeholder="$t('company.one')"
      :options="this.companies"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="name"
      option-value="id" />

    <!--HOTE-->
    <AkAutocomplete
      ref="ownerAutocomplete"
      v-model="currentValue.ownerId"
      :inline="true"
      :label="$t('owner.ownerDisplay')"
      option-value="id"
      option-label="display"
      @item-select="itemSelect"
      :force-selection="false"
      :init-method="this.autocompleteOwnerById"
      :search-method="this.autocompleteOwner"
      :search-object="this.autocompleteOwnerCustomer()"
      :search-label="this.autocompleteOwnerQuery" />

    <!--LOGEMENT-->
    <AkAutocomplete
      @valueChange="itemSelect"
      ref="accommodationAutocomplete"
      v-model="currentValue.accommodationId"
      :inline="true"
      :minLengthToLaunchSearch="3"
      :label="$t('accommodation.short')"
      option-value="id"
      option-label="display"
      @item-select="itemSelect"
      :force-selection="false"
      :init-method="this.autocompleteAccommodationById"
      :search-method="this.isHousekeeper() ? this.autocompleteHousekeeperAccommodation : this.autocompleteAccommodation"
      :search-label="this.autocompleteAccommodationQuery" />

    <!-- Mandat -->
    <AkAutocomplete
      ref="mandatAutocomplete"
      v-model="currentValue.mandatId"
      :init-method="autocompleteMandatById"
      :label="$t('mandat.details')"
      :search-method="autocompleteMandat"
      inline
      option-label="num"
      option-value="id"
      @item-select="itemSelect" />

    <!--PERIOD-->
    <AkCalendar
      v-model="currentValue.period"
      :inline="true"
      @valueChange="itemSelect"
      :placeholder="$t('period.title')"
      date-format="dd/mm/yy"
      selection="range" />

    <!--TYPES DE FACTURATION-->
    <MultiSelect
      @change="itemSelect"
      v-model="currentValue.transactionTypes"
      placeholder="Types de facturation"
      :options="accountOperationsConstForRecapitulatif"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="label"
      option-value="value" />

    <!-- Marche -->
    <MultiSelect
      v-model="currentValue.marchesId"
      :options="mandatMarcheList"
      :loading="mandatMarcheList === undefined"
      :placeholder="$t('item_label.marche')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="label"
      option-value="id"
      @change="itemSelect" />

    <AkButtonFooterSidebarFilter :validateLabel="$t('search.search')" @action="search" @reset="reset" />
  </form>
</template>
